"use strict";
/**
 * ID 生成工具
 * 生成格式: {PREFIX}_{RANDOM6}
 * 總長度: 10字元
 * 字元集: A-Z, 0-9 (36進位)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_PREFIXES = void 0;
exports.generateCustomId = generateCustomId;
exports.generateCustomerId = generateCustomerId;
exports.generateProjectId = generateProjectId;
exports.generateQuoteId = generateQuoteId;
exports.generateQuoteItemId = generateQuoteItemId;
exports.generatePaymentId = generatePaymentId;
exports.generateInteractionId = generateInteractionId;
exports.generateActivityId = generateActivityId;
exports.generateTaskId = generateTaskId;
exports.generateTagId = generateTagId;
exports.generateTagAssignmentId = generateTagAssignmentId;
exports.generateOpportunityId = generateOpportunityId;
exports.generateStageId = generateStageId;
exports.generateStageHistoryId = generateStageHistoryId;
exports.generateOrganizationId = generateOrganizationId;
exports.generateUserId = generateUserId;
exports.generatePlanId = generatePlanId;
exports.generateSubscriptionId = generateSubscriptionId;
exports.generateTransactionId = generateTransactionId;
exports.isValidCustomId = isValidCustomId;
exports.extractPrefix = extractPrefix;
exports.generateMultipleIds = generateMultipleIds;
exports.generateBankAccountId = generateBankAccountId;
exports.generateBankTransactionId = generateBankTransactionId;
exports.generateAccountId = generateAccountId;
exports.generateJournalEntryId = generateJournalEntryId;
exports.generateJournalEntryDetailId = generateJournalEntryDetailId;
exports.generateFiscalYearId = generateFiscalYearId;
exports.generateAccountingPeriodId = generateAccountingPeriodId;
exports.generateStatementImportRecordId = generateStatementImportRecordId;
exports.generateStatementTransactionId = generateStatementTransactionId;
exports.generateInvoiceId = generateInvoiceId;
exports.generateInvoiceItemId = generateInvoiceItemId;
exports.generatePeriodClosingId = generatePeriodClosingId;
exports.generateClosingEntryId = generateClosingEntryId;
exports.generateUniformInvoiceTrackId = generateUniformInvoiceTrackId;
exports.generateUniformInvoiceVoidId = generateUniformInvoiceVoidId;
exports.generateUniformInvoiceAllowanceId = generateUniformInvoiceAllowanceId;
exports.generateYearEndEntryId = generateYearEndEntryId;
exports.generatePMProjectId = generatePMProjectId;
exports.generateRequirementId = generateRequirementId;
exports.generateMilestoneId = generateMilestoneId;
exports.generatePMTaskId = generatePMTaskId;
exports.generatePMPaymentId = generatePMPaymentId;
exports.generatePMStageHistoryId = generatePMStageHistoryId;
exports.generatePMFileId = generatePMFileId;
exports.generatePMPackageId = generatePMPackageId;
exports.generateServiceItemId = generateServiceItemId;
exports.generateStaffId = generateStaffId;
exports.generateCustomerAccountId = generateCustomerAccountId;
exports.generateBookingId = generateBookingId;
exports.generateStoreCustomerId = generateStoreCustomerId;
// ID 前綴定義
exports.ID_PREFIXES = {
    // CRM Backend Models
    CUSTOMER: 'CUS_',
    PROJECT: 'PRJ_',
    QUOTE: 'QTE_',
    QUOTE_ITEM: 'QTI_',
    PAYMENT: 'PAY_',
    INTERACTION: 'INT_',
    ACTIVITY: 'ACT_',
    CUSTOMER_TASK: 'TSK_',
    CUSTOMER_TAG: 'TAG_',
    CUSTOMER_TAG_ASSIGNMENT: 'TGA_',
    CUSTOMER_OPPORTUNITY: 'OPP_',
    OPPORTUNITY_STAGE: 'STG_',
    OPPORTUNITY_STAGE_HISTORY: 'HST_',
    // Identity Service Models
    ORGANIZATION: 'ORG_',
    USER: 'USR_',
    // Subscription Service Models
    PLAN: 'PLN_',
    SUBSCRIPTION: 'SUB_',
    TRANSACTION: 'TXN_',
    // Accounting Service Models
    BANK_ACCOUNT: 'BAK_',
    BANK_TRANSACTION: 'BTX_',
    ACCOUNT: 'ACC_',
    JOURNAL_ENTRY: 'JNL_',
    JOURNAL_ENTRY_DETAIL: 'JTL_',
    FISCAL_YEAR: 'FYR_',
    ACCOUNTING_PERIOD: 'APD_',
    STATEMENT_IMPORT_RECORD: 'SIR_',
    STATEMENT_TRANSACTION: 'STX_',
    INVOICE: 'INV_',
    INVOICE_ITEM: 'IVI_',
    PERIOD_CLOSING: 'PCL_',
    CLOSING_ENTRY: 'CLE_',
    UNIFORM_INVOICE_TRACK: 'UIT_',
    UNIFORM_INVOICE_VOID: 'UIV_',
    UNIFORM_INVOICE_ALLOWANCE: 'UIA_',
    YEAR_END_ENTRY: 'YEE_',
    // PM (Project Management) Service Models
    PM_PROJECT: 'PMP_',
    PM_REQUIREMENT: 'REQ_',
    PM_MILESTONE: 'MLS_',
    PM_TASK: 'PMT_',
    PM_PAYMENT: 'PPY_',
    PM_STAGE_HISTORY: 'PSH_',
    PM_FILE: 'PMF_',
    PM_PACKAGE: 'PKG_',
    // Store Service Models
    // Note: STORE ID 直接使用 organizationId，不需要獨立生成
    SERVICE_ITEM: 'SRV_',
    STAFF: 'STF_',
    CUSTOMER_ACCOUNT: 'CUA_', // 終端客戶帳號
    BOOKING: 'BOK_',
    STORE_CUSTOMER: 'SCU_',
};
// 字元集 (36進位: 0-9, A-Z)
const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
/**
 * 生成自定義 ID
 * @param prefix ID 前綴 (如 'CUS_', 'PRJ_' 等)
 * @returns 格式化的 ID (如 'CUS_A1B2C3')
 */
function generateCustomId(prefix) {
    let randomPart = '';
    // 生成 6 位隨機字元
    for (let i = 0; i < 6; i++) {
        randomPart += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
    }
    return prefix + randomPart;
}
/**
 * 生成客戶 ID
 * @returns 客戶 ID (如 'CUS_A1B2C3')
 */
function generateCustomerId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER);
}
/**
 * 生成專案 ID
 * @returns 專案 ID (如 'PRJ_X7Y8Z9')
 */
function generateProjectId() {
    return generateCustomId(exports.ID_PREFIXES.PROJECT);
}
/**
 * 生成報價 ID
 * @returns 報價 ID (如 'QTE_M3N4P5')
 */
function generateQuoteId() {
    return generateCustomId(exports.ID_PREFIXES.QUOTE);
}
/**
 * 生成報價項目 ID
 * @returns 報價項目 ID (如 'QTI_K6L7M8')
 */
function generateQuoteItemId() {
    return generateCustomId(exports.ID_PREFIXES.QUOTE_ITEM);
}
/**
 * 生成付款 ID
 * @returns 付款 ID (如 'PAY_R9S1T2')
 */
function generatePaymentId() {
    return generateCustomId(exports.ID_PREFIXES.PAYMENT);
}
/**
 * 生成互動 ID
 * @returns 互動 ID (如 'INT_V4W5X6')
 */
function generateInteractionId() {
    return generateCustomId(exports.ID_PREFIXES.INTERACTION);
}
/**
 * 生成活動 ID
 * @returns 活動 ID (如 'ACT_H7J8K9')
 */
function generateActivityId() {
    return generateCustomId(exports.ID_PREFIXES.ACTIVITY);
}
/**
 * 生成任務 ID
 * @returns 任務 ID (如 'TSK_B2C3D4')
 */
function generateTaskId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER_TASK);
}
/**
 * 生成標籤 ID
 * @returns 標籤 ID (如 'TAG_F5G6H7')
 */
function generateTagId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER_TAG);
}
/**
 * 生成標籤分配 ID
 * @returns 標籤分配 ID (如 'TGA_J8K9L1')
 */
function generateTagAssignmentId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER_TAG_ASSIGNMENT);
}
/**
 * 生成商機 ID
 * @returns 商機 ID (如 'OPP_N2P3Q4')
 */
function generateOpportunityId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER_OPPORTUNITY);
}
/**
 * 生成階段 ID
 * @returns 階段 ID (如 'STG_S5T6U7')
 */
function generateStageId() {
    return generateCustomId(exports.ID_PREFIXES.OPPORTUNITY_STAGE);
}
/**
 * 生成階段歷史 ID
 * @returns 階段歷史 ID (如 'HST_W8X9Y1')
 */
function generateStageHistoryId() {
    return generateCustomId(exports.ID_PREFIXES.OPPORTUNITY_STAGE_HISTORY);
}
/**
 * 生成組織 ID
 * @returns 組織 ID (如 'ORG_Z2A3B4')
 */
function generateOrganizationId() {
    return generateCustomId(exports.ID_PREFIXES.ORGANIZATION);
}
/**
 * 生成使用者 ID
 * @returns 使用者 ID (如 'USR_C5D6E7')
 */
function generateUserId() {
    return generateCustomId(exports.ID_PREFIXES.USER);
}
/**
 * 生成方案 ID
 * @returns 方案 ID (如 'PLN_F8G9H1')
 */
function generatePlanId() {
    return generateCustomId(exports.ID_PREFIXES.PLAN);
}
/**
 * 生成訂閱 ID
 * @returns 訂閱 ID (如 'SUB_J2K3L4')
 */
function generateSubscriptionId() {
    return generateCustomId(exports.ID_PREFIXES.SUBSCRIPTION);
}
/**
 * 生成交易 ID
 * @returns 交易 ID (如 'TXN_M5N6P7')
 */
function generateTransactionId() {
    return generateCustomId(exports.ID_PREFIXES.TRANSACTION);
}
/**
 * 驗證 ID 格式是否正確
 * @param id 要驗證的 ID
 * @returns 是否為有效的自定義 ID 格式
 */
function isValidCustomId(id) {
    // 檢查長度是否為 10
    if (id.length !== 10)
        return false;
    // 檢查是否包含底線分隔符
    if (!id.includes('_'))
        return false;
    // 分離前綴和後綴
    const parts = id.split('_');
    if (parts.length !== 2)
        return false;
    const [prefix, suffix] = parts;
    // 檢查前綴長度
    if (prefix.length !== 3)
        return false;
    // 檢查後綴長度
    if (suffix.length !== 6)
        return false;
    // 檢查後綴是否只包含有效字元
    for (const char of suffix) {
        if (!CHARS.includes(char))
            return false;
    }
    return true;
}
/**
 * 從 ID 中提取前綴
 * @param id 完整的 ID
 * @returns ID 前綴 (如 'CUS_')
 */
function extractPrefix(id) {
    const parts = id.split('_');
    return parts.length >= 2 ? parts[0] + '_' : '';
}
/**
 * 批量生成 ID
 * @param prefix ID 前綴
 * @param count 生成數量
 * @returns ID 陣列
 */
function generateMultipleIds(prefix, count) {
    const ids = [];
    for (let i = 0; i < count; i++) {
        ids.push(generateCustomId(prefix));
    }
    return ids;
}
// === 會計系統 ID 生成函數 ===
/**
 * 生成銀行帳戶 ID
 * @returns 銀行帳戶 ID (如 'BAK_A1B2C3')
 */
function generateBankAccountId() {
    return generateCustomId(exports.ID_PREFIXES.BANK_ACCOUNT);
}
/**
 * 生成銀行交易 ID
 * @returns 銀行交易 ID (如 'BTX_X7Y8Z9')
 */
function generateBankTransactionId() {
    return generateCustomId(exports.ID_PREFIXES.BANK_TRANSACTION);
}
/**
 * 生成會計科目 ID
 * @returns 會計科目 ID (如 'ACC_M3N4P5')
 */
function generateAccountId() {
    return generateCustomId(exports.ID_PREFIXES.ACCOUNT);
}
/**
 * 生成記帳分錄 ID
 * @returns 記帳分錄 ID (如 'JNL_K6L7M8')
 */
function generateJournalEntryId() {
    return generateCustomId(exports.ID_PREFIXES.JOURNAL_ENTRY);
}
/**
 * 生成記帳分錄明細 ID
 * @returns 記帳分錄明細 ID (如 'JTL_R9S1T2')
 */
function generateJournalEntryDetailId() {
    return generateCustomId(exports.ID_PREFIXES.JOURNAL_ENTRY_DETAIL);
}
/**
 * 生成會計年度 ID
 * @returns 會計年度 ID (如 'FYR_V4W5X6')
 */
function generateFiscalYearId() {
    return generateCustomId(exports.ID_PREFIXES.FISCAL_YEAR);
}
/**
 * 生成會計期間 ID
 * @returns 會計期間 ID (如 'APD_H7J8K9')
 */
function generateAccountingPeriodId() {
    return generateCustomId(exports.ID_PREFIXES.ACCOUNTING_PERIOD);
}
/**
 * 生成對帳單匯入記錄 ID
 * @returns 對帳單匯入記錄 ID (如 'SIR_B2C3D4')
 */
function generateStatementImportRecordId() {
    return generateCustomId(exports.ID_PREFIXES.STATEMENT_IMPORT_RECORD);
}
/**
 * 生成對帳單交易 ID
 * @returns 對帳單交易 ID (如 'STX_F5G6H7')
 */
function generateStatementTransactionId() {
    return generateCustomId(exports.ID_PREFIXES.STATEMENT_TRANSACTION);
}
/**
 * 生成發票 ID
 * @returns 發票 ID (如 'INV_J8K9L1')
 */
function generateInvoiceId() {
    return generateCustomId(exports.ID_PREFIXES.INVOICE);
}
/**
 * 生成發票項目 ID
 * @returns 發票項目 ID (如 'IVI_N2P3Q4')
 */
function generateInvoiceItemId() {
    return generateCustomId(exports.ID_PREFIXES.INVOICE_ITEM);
}
/**
 * 生成期間結算 ID
 * @returns 期間結算 ID (如 'PCL_S5T6U7')
 */
function generatePeriodClosingId() {
    return generateCustomId(exports.ID_PREFIXES.PERIOD_CLOSING);
}
/**
 * 生成結帳分錄 ID
 * @returns 結帳分錄 ID (如 'CLE_W8X9Y1')
 */
function generateClosingEntryId() {
    return generateCustomId(exports.ID_PREFIXES.CLOSING_ENTRY);
}
/**
 * 生成統一發票字軌 ID
 * @returns 統一發票字軌 ID (如 'UIT_Z2A3B4')
 */
function generateUniformInvoiceTrackId() {
    return generateCustomId(exports.ID_PREFIXES.UNIFORM_INVOICE_TRACK);
}
/**
 * 生成統一發票作廢 ID
 * @returns 統一發票作廢 ID (如 'UIV_C5D6E7')
 */
function generateUniformInvoiceVoidId() {
    return generateCustomId(exports.ID_PREFIXES.UNIFORM_INVOICE_VOID);
}
/**
 * 生成統一發票折讓 ID
 * @returns 統一發票折讓 ID (如 'UIA_F8G9H1')
 */
function generateUniformInvoiceAllowanceId() {
    return generateCustomId(exports.ID_PREFIXES.UNIFORM_INVOICE_ALLOWANCE);
}
/**
 * 生成年度結算分錄 ID
 * @returns 年度結算分錄 ID (如 'YEE_P2Q3R4')
 */
function generateYearEndEntryId() {
    return generateCustomId(exports.ID_PREFIXES.YEAR_END_ENTRY);
}
// === 專案管理系統 (PM) ID 生成函數 ===
/**
 * 生成 PM 專案 ID
 * @returns PM 專案 ID (如 'PMP_A1B2C3')
 */
function generatePMProjectId() {
    return generateCustomId(exports.ID_PREFIXES.PM_PROJECT);
}
/**
 * 生成需求 ID
 * @returns 需求 ID (如 'REQ_X7Y8Z9')
 */
function generateRequirementId() {
    return generateCustomId(exports.ID_PREFIXES.PM_REQUIREMENT);
}
/**
 * 生成里程碑 ID
 * @returns 里程碑 ID (如 'MLS_M3N4P5')
 */
function generateMilestoneId() {
    return generateCustomId(exports.ID_PREFIXES.PM_MILESTONE);
}
/**
 * 生成 PM 任務 ID
 * @returns PM 任務 ID (如 'PMT_K6L7M8')
 */
function generatePMTaskId() {
    return generateCustomId(exports.ID_PREFIXES.PM_TASK);
}
/**
 * 生成 PM 付款 ID
 * @returns PM 付款 ID (如 'PPY_R9S1T2')
 */
function generatePMPaymentId() {
    return generateCustomId(exports.ID_PREFIXES.PM_PAYMENT);
}
/**
 * 生成 PM 階段歷史 ID
 * @returns PM 階段歷史 ID (如 'PSH_V4W5X6')
 */
function generatePMStageHistoryId() {
    return generateCustomId(exports.ID_PREFIXES.PM_STAGE_HISTORY);
}
/**
 * 生成 PM 檔案 ID
 * @returns PM 檔案 ID (如 'PMF_H7J8K9')
 */
function generatePMFileId() {
    return generateCustomId(exports.ID_PREFIXES.PM_FILE);
}
/**
 * 生成 PM 專案包（分包報價）ID
 * @returns PM 包 ID (如 'PKG_A1B2C3')
 */
function generatePMPackageId() {
    return generateCustomId(exports.ID_PREFIXES.PM_PACKAGE);
}
// === 店鋪服務系統 (Store Service) ID 生成函數 ===
// Note: Store ID 直接使用 organizationId，不需要 generateStoreId()
/**
 * 生成服務項目 ID
 * @returns 服務項目 ID (如 'SRV_X7Y8Z9')
 */
function generateServiceItemId() {
    return generateCustomId(exports.ID_PREFIXES.SERVICE_ITEM);
}
/**
 * 生成員工 ID
 * @returns 員工 ID (如 'STF_M3N4P5')
 */
function generateStaffId() {
    return generateCustomId(exports.ID_PREFIXES.STAFF);
}
/**
 * 生成終端客戶帳號 ID
 * @returns 客戶帳號 ID (如 'CUA_K6L7M8')
 */
function generateCustomerAccountId() {
    return generateCustomId(exports.ID_PREFIXES.CUSTOMER_ACCOUNT);
}
/**
 * 生成預約 ID
 * @returns 預約 ID (如 'BOK_R9S1T2')
 */
function generateBookingId() {
    return generateCustomId(exports.ID_PREFIXES.BOOKING);
}
/**
 * 生成店鋪客戶關聯 ID
 * @returns 店鋪客戶 ID (如 'SCU_V4W5X6')
 */
function generateStoreCustomerId() {
    return generateCustomId(exports.ID_PREFIXES.STORE_CUSTOMER);
}
